import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e16af5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 1,
  class: "teams-topics"
}
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "title-bar" }
const _hoisted_5 = {
  key: 0,
  class: "grid-container"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "topic-title" }
const _hoisted_9 = { class: "topic-item-title" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "topic-title" }
const _hoisted_12 = { class: "topic-item-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "nps-container"
}
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingCard = _resolveComponent("LoadingCard")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_NPSLineGraph = _resolveComponent("NPSLineGraph")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.teamFilterSelected === null)
      ? (_openBlock(), _createBlock(_component_LoadingCard, {
          key: 0,
          borderless: false,
          variant: "columns"
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.tsScorecard && _ctx.tsScorecard.tsgroups.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.customerLoves.length)
                ? (_openBlock(), _createBlock(_component_Typography, {
                    key: 0,
                    variant: "overline",
                    class: "topic-title"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.title), 1)
                    ], undefined, true),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Typography, {
                variant: "subtitle2",
                class: "topic-tab"
              }, {
                default: _withCtx(() => [
                  (
                                !_ctx.$companyVars.has_individually_rated_scorecard
                            )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["count-metric", [
                                _ctx.displayState === 'COUNT'
                                    ? 'count-metric-selected'
                                    : 'dim',
                            ]]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDisplay('COUNT')))
                      }, "COUNT", 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["count-metric", [
                                _ctx.displayState === 'METRIC'
                                    ? 'count-metric-selected'
                                    : 'dim',
                            ]]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDisplay('METRIC')))
                  }, _toDisplayString(_ctx.scoreType), 3)
                ], undefined, true),
                _: 1
              })
            ]),
            (_ctx.displayState === 'COUNT')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_Typography, {
                    variant: "overline",
                    class: "grid-item success-green total"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Customer Love")
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_Typography, {
                    variant: "overline",
                    class: "grid-item warning-orange total"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Focus Area")
                    ], undefined, true),
                    _: 1
                  }),
                  (_ctx.customerLoves.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerLoves, (topic, topicIdx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: topicIdx,
                            class: "grid-item",
                            onClick: ($event: any) => (
                                _ctx.showTopicFilteredFeedback(topic, 'promoters')
                            )
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_FontAwesomeIcon, {
                                icon: _ctx.faArrowCircleRight,
                                size: "xs",
                                class: "group-arrow-icon"
                              }, null, 8, ["icon"]),
                              _createVNode(_component_Typography, { variant: "body2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(topic.group), 1)
                                ], undefined, true),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("div", {
                              class: "magnitude-line success-green-as-background",
                              style: _normalizeStyle({
                                    width:
                                        _ctx.asPercentage(
                                            topic.respondedPromoter,
                                            _ctx.totalCustomersLove()
                                        ) + '%',
                                })
                            }, null, 4),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.asPercentage(
                                        topic.respondedPromoter,
                                        _ctx.totalCustomersLove()
                                    )) + "%", 1)
                          ], 8, _hoisted_7))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.focusAreas, (topic, topicIdx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: topicIdx,
                        class: "grid-item",
                        onClick: ($event: any) => (
                                _ctx.showTopicFilteredFeedback(topic, 'detractors')
                            )
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: _ctx.faArrowCircleRight,
                            size: "xs",
                            class: "group-arrow-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_Typography, { variant: "body2" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(topic.group), 1)
                            ], undefined, true),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", {
                          class: "magnitude-line warning-orange-as-background",
                          style: _normalizeStyle({
                                    width:
                                        _ctx.asPercentage(
                                            topic.respondedDetractor,
                                            _ctx.totalFocusAreas()
                                        ) + '%',
                                })
                        }, null, 4),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.asPercentage(
                                        topic.respondedDetractor,
                                        _ctx.totalFocusAreas()
                                    )) + "%", 1)
                      ], 8, _hoisted_10))
                    }), 128))
                  ]),
                  _createVNode(_component_Typography, {
                    variant: "overline",
                    class: "grid-item success-green total"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Total"),
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_ctx.totalCustomersLove()), 1)
                    ], undefined, true),
                    _: 1
                  }),
                  _createVNode(_component_Typography, {
                    variant: "overline",
                    class: "grid-item warning-orange total"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Total"),
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(_ctx.totalFocusAreas()), 1)
                    ], undefined, true),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.displayState === 'METRIC')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tsScorecard.tsgroups, (topic, index) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "grid-itemx",
                      onClick: ($event: any) => (_ctx.showTopicFilteredFeedback(topic))
                    }, [
                      _createVNode(_component_NPSLineGraph, {
                        group: topic.group,
                        average: Number(_ctx.tsScorecard.averageNPS),
                        nps: Number(topic.NPS),
                        "score-type": _ctx.scoreType,
                        "previous-nps": Number(topic.previousNPS),
                        "show-goal": Boolean(index === 0),
                        goal: _ctx.scoreTarget
                      }, null, 8, ["group", "average", "nps", "score-type", "previous-nps", "show-goal", "goal"])
                    ], 8, _hoisted_16)), [
                      [_vShow, _ctx.tsScorecard]
                    ])
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}